import React, { PropTypes } from 'react';
import {
  NitroHeading,
  NitroDivider,
  NitroParagraph,
  NitroLoading,
  NitroDefinition,
  NitroPanel,
} from 'nitro-components';

import { VehicleDetails } from '../../../../components/vehicle';

import {
  VEHICLE_DETAIL_HEADING,
  VEHICLE_INFO_REGISTRATION,
  VEHICLE_INFO_DRIVER,
  VEHICLE_INFO_COSTCENTER_HEADING,
  VEHICLE_COSTCENTER_HISTORY,
} from '../content';

import CostcenterHistory from './CostcenterHistory';

import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
`;

const VehicleCostcenterDetails = ({ vehicle, fetchingVehicleDetails }) => {
  const {
    DriverFirstName,
    DriverSurname,
    RegistrationNumber,
    CompanyName,
    CostCentre,
    CostCentreVehicleAllocation,
    ShouldDisplayHistory
  } = vehicle;

  const hasCostCentre = !/no cost/gi.test(CostCentre);

  const vehicleInfo = [
    {
      title: VEHICLE_INFO_REGISTRATION,
      description: RegistrationNumber,
    },
    {
      title: VEHICLE_INFO_DRIVER,
      description: `${DriverFirstName} ${DriverSurname}`,
    },
  ];

  const quoteSummary = (
    <section>
      <NitroPanel>
        <VehicleDetails {...vehicle} horizontal />
      </NitroPanel>
      <NitroDivider />
      <NitroDefinition data={vehicleInfo} />
      <NitroDivider />
    </section>
  );

  return fetchingVehicleDetails ? (
    <NitroLoading position="center" />
  ) : (
      <Wrapper>
        <NitroHeading label={VEHICLE_DETAIL_HEADING} />
        {quoteSummary}
        <NitroHeading label={VEHICLE_INFO_COSTCENTER_HEADING} size="3" />
        <NitroParagraph noMargin>{CompanyName}</NitroParagraph>
        {hasCostCentre && (
          <NitroParagraph variant="base3" noMargin>
            {CostCentre}
          </NitroParagraph>
        )}
        {ShouldDisplayHistory && (
          <div>
            <NitroDivider />
            <NitroHeading label={VEHICLE_COSTCENTER_HISTORY} size="3" />
            <CostcenterHistory list={CostCentreVehicleAllocation || []} />
          </div>)}
      </Wrapper>
    );
};

VehicleCostcenterDetails.propTypes = {
  vehicle: PropTypes.object,
  fetchingVehicleDetails: PropTypes.bool,
};

export default VehicleCostcenterDetails;



// WEBPACK FOOTER //
// ./src/features/relocations/vehicle/components/VehicleCostcenterDetails.js